import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Tooltip } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import Avatar from "../../../../components/Avatar";
import { createAvtarName } from "../../../../utils";
import { useDispatch } from "react-redux";
import {
  setAllGroupUser,
  setGroupUser,
} from "../../../../redux/TaskGroupingSlice";

const UnassignedUsersAccordion = React.memo(({
  unAssignedTeam,
  user,
  setUnassigned,
  searchQuery,
  openUnassigned,
}) => {
  const dispatch = useDispatch();
  const [manualOverride, setManualOverride] = useState(false);
  const [wasSearching, setWasSearching] = useState(false);

  const shouldBeExpanded = useMemo(() => {
    return searchQuery && !manualOverride ? unAssignedTeam.length > 0 : openUnassigned;
  }, [searchQuery, manualOverride, unAssignedTeam.length, openUnassigned]);

  const areAllUnassignedSelected = useMemo(() => {
    if (!unAssignedTeam.length) return false;
    const selectedUserIds = new Set(user.map(u => u.user_id));
    return unAssignedTeam.every((ele) => selectedUserIds.has(ele.user_id));
  }, [unAssignedTeam, user]);

  useEffect(() => {
    if (searchQuery) {
      setWasSearching(true);
    } else if (!searchQuery && wasSearching) {
      setManualOverride(false);
      setUnassigned(false);
      setWasSearching(false);
    }
  }, [searchQuery, setUnassigned, wasSearching]);

  const setUnassingUser = useCallback((teamUser, isChecked) => {
    dispatch(setAllGroupUser([]));

    if (isChecked) {
      user.forEach((element) => {
        if (element.team_id) {
          dispatch(setGroupUser(element));
        }
      });
    } else {
      teamUser.forEach((element) => {
        dispatch(setGroupUser(element));
      });

      user.forEach((element) => {
        if (element.team_id) {
          dispatch(setGroupUser(element));
        }
      });
    }
  }, [dispatch, user]);

  const handleAccordionChange = useCallback((event, isExpanded) => {
    // Track manual user interaction
    if (searchQuery) {
      setManualOverride(true);
    }
    setUnassigned(isExpanded);
  }, [searchQuery, setUnassigned]);

  const handleCheckboxClick = useCallback((event) => {
    event.stopPropagation();
    setUnassingUser(unAssignedTeam, areAllUnassignedSelected);
  }, [setUnassingUser, unAssignedTeam, areAllUnassignedSelected]);

  const handleUserClick = useCallback((el) => {
    dispatch(setGroupUser(el));
  }, [dispatch]);

  const tooltipTitle = useMemo(() => {
    return searchQuery && shouldBeExpanded ? "Click to collapse" : "";
  }, [searchQuery, shouldBeExpanded]);

  return (
    <Accordion
      expanded={shouldBeExpanded}
      onChange={handleAccordionChange}
      className="unassigned-accordion">
      <Tooltip 
        title={tooltipTitle}
        placement="top"
        arrow
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header">
          <label className="custom-checkbox">
            <input
              type="checkbox"
              checked={areAllUnassignedSelected}
              onClick={handleCheckboxClick}
              onChange={()=>{}}
            />
            <span className="checkmark"></span>
            Unassigned Users
          </label>
        </AccordionSummary>
      </Tooltip>
      <AccordionDetails className="accordion-details">
        {unAssignedTeam.map((el, index) => (
          <CustomMenuItem
            key={`user-avtar-dropdown-admin-assign-${el.user_id}`}
            onClick={() => {
              handleUserClick(el);
            }}>
            <label className="custom-checkbox">
              <input
                type="checkbox"
                id={`user-check-box-${el.user_id}`}
                checked={user.some((element) => element.user_id == el.user_id)}
                onClick={(event) => {
                  event.stopPropagation();
                }}
                onChange={()=>{}}
              />
              <span className="checkmark"></span>

              <Avatar
                key={`user-avtar-${el.user_id}`}
                username={`${el.first_name} ${el.last_name}`}
                user_image={el.user_image}
                title={`${el.first_name} ${el.last_name}`}
                className="user-avtar-dropdown user-avatar mr-8">
                {createAvtarName(`${el.first_name} ${el.last_name}`)}
              </Avatar>
              {`${el.first_name} ${el.last_name}`}
            </label>
          </CustomMenuItem>
        ))}
      </AccordionDetails>
    </Accordion>
  );
});

export default UnassignedUsersAccordion;
